import { SvgIcon, useTheme } from "@material-ui/core";
import React, {
  ButtonHTMLAttributes,
  CSSProperties,
  DetailedHTMLProps,
  useMemo,
} from "react";

interface FilterButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color: "primary" | "sand" | "slateblue";
  variant: "contained" | "outlined";
  fontSize?: number;
}

export const FilterButton = (props: FilterButtonProps) => {
  const { fontSize, color, variant, ...rest } = props;
  const theme = useTheme();

  const themeColor = useMemo(() => {
    switch (color) {
      case "primary":
        return theme.palette.primary.main;
      case "sand":
        return theme.palette.app_sand.dark;
      case "slateblue":
        return theme.palette.app_slate.main;
    }
  }, [color, theme.palette]);

  const themeContrastColor = useMemo(() => {
    switch (color) {
      case "primary":
        return theme.palette.primary.contrastText;
      case "sand":
        return theme.palette.app_sand.light;
      case "slateblue":
        return theme.palette.app_slate.contrastText;
    }
  }, [color, theme.palette]);

  const selected0: CSSProperties = {
    fill: "none",
    stroke: themeColor,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
  };

  const selected1: CSSProperties = {
    fill: "none",
    stroke: themeContrastColor,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
  };

  const selected2: CSSProperties = {
    fill: themeContrastColor,
    stroke: themeColor,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
  };

  const selected3: CSSProperties = {
    fill: themeColor,
  };

  const default0: CSSProperties = {
    fill: "none",
    stroke: themeColor,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
  };

  const default1: CSSProperties = {
    fill: themeColor,
    stroke: themeContrastColor,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
  };

  const default2: CSSProperties = {
    fill: "none",
    stroke: themeColor,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
  };

  const default3: CSSProperties = {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
  };

  const default4: CSSProperties = {
    fill: themeColor,
  };

  const default5: CSSProperties = {
    fill: themeContrastColor,
  };

  const default6: CSSProperties = {
    opacity: 0,
  };

  return (
    <button {...rest}>
      {variant === "contained" ? (
        <SvgIcon style={{ fontSize: fontSize }} viewBox="0 0 72 72">
          <g>
            <rect
              style={default5}
              x="1.9"
              y="1"
              width="68.2"
              height="70.2"
              rx="5.8"
              ry="5.8"
            />
            <rect
              style={default0}
              x="1.9"
              y="1"
              width="68.2"
              height="70.2"
              rx="5.8"
              ry="5.8"
            />
          </g>
          <line style={default2} x1="14.1" y1="21" x2="57.3" y2="21" />
          <line style={default2} x1="14.1" y1="36.3" x2="57.3" y2="36.3" />
          <line style={default2} x1="14.1" y1="51.7" x2="57.3" y2="51.7" />
          <circle style={default1} cx="44.4" cy="21" r="5.4" />
          <circle style={default1} cx="24.8" cy="36" r="5.4" />
          <circle style={default1} cx="37.5" cy="51.7" r="5.4" />
          <g style={default6}>
            <rect
              style={default4}
              x="1.9"
              y=".8"
              width="68.2"
              height="70.2"
              rx="5.8"
              ry="5.8"
            />
            <rect
              style={default3}
              x="1.9"
              y=".8"
              width="68.2"
              height="70.2"
              rx="5.8"
              ry="5.8"
            />
          </g>
        </SvgIcon>
      ) : (
        <SvgIcon style={{ fontSize: 40 }} viewBox="0 0 72 72">
          <g>
            <rect
              style={selected3}
              x="1.9"
              y=".9"
              width="68.2"
              height="70.3"
              rx="5.8"
              ry="5.8"
            />
            <rect
              style={selected0}
              x="1.9"
              y=".9"
              width="68.2"
              height="70.3"
              rx="5.8"
              ry="5.8"
            />
          </g>
          <line style={selected1} x1="14.1" y1="20.9" x2="57.3" y2="20.9" />
          <line style={selected1} x1="14.1" y1="36.3" x2="57.3" y2="36.3" />
          <line style={selected1} x1="14.1" y1="51.7" x2="57.3" y2="51.7" />
          <ellipse style={selected2} cx="44.4" cy="20.9" rx="5.4" ry="5.4" />
          <ellipse style={selected2} cx="24.8" cy="36" rx="5.4" ry="5.4" />
          <ellipse style={selected2} cx="37.5" cy="51.7" rx="5.4" ry="5.4" />
        </SvgIcon>
      )}
    </button>
  );
};
